/* eslint-disable ember/no-runloop */
import { tracked } from '@glimmer/tracking';
import InputLabel from '@linc-technologies/linced-common/components/input-label';
import { cancel, next } from '@ember/runloop';
import { isPresent } from '@ember/utils';

export default class ChipsLabel extends InputLabel {
  // `@tracked` so `hasValue` updates when the caller assigns a new array.
  @tracked content = null;

  // `hasValueOverride` lets callers override the default; Ember < 4 allowed
  // that implicitly (computed-property.override).
  @tracked hasValueOverride = null;

  // Plain getter, not `@computed`: the classNameBindings read it in a
  // tracking frame, so a new array and in-place changes to a `TrackedArray`
  // both update the class.
  get hasValue() {
    if (this.hasValueOverride !== null) {
      return this.hasValueOverride;
    }

    return isPresent(this.content);
  }

  focusOutTimer = null;

  focusOut() {
    if (isPresent(this.focusOutTimer)) {
      cancel(this.focusOutTimer);
    }
    this.focusOutTimer = next(this, super.focusOut);
  }

  focusIn() {
    if (isPresent(this.focusOutTimer)) {
      cancel(this.focusOutTimer);
    }
    next(this, super.focusIn);
  }
}
